import AsyncStorage from '../async-storage-chunker';
import { clearOfflineAsyncStorage } from './offline-mode-storage';
import { v4 as uuidv4 } from 'uuid';

const OFFLINE_MODE_SIMULATED_KEY = 'OFFLINE_MODE_SIMULATED';

export class OfflineModeSimulator {
  private static instance: OfflineModeSimulator;
  private static listeners: {
    [listenerId: string]: (isEnabled: boolean) => void;
  };
  private isEnabled = false;

  private constructor() {}

  public static getInstance(): OfflineModeSimulator {
    if (!OfflineModeSimulator.instance) {
      const simulator = new OfflineModeSimulator();
      OfflineModeSimulator.instance = simulator;
    }
    return OfflineModeSimulator.instance;
  }

  public async hydrate() {
    const storedValue = await AsyncStorage.getItem(OFFLINE_MODE_SIMULATED_KEY);
    this.isEnabled = JSON.parse(storedValue || 'false');
  }

  public async toggleEnabled() {
    this.isEnabled = !this.isEnabled;
    await AsyncStorage.setItem(
      OFFLINE_MODE_SIMULATED_KEY,
      JSON.stringify(this.isEnabled),
    );

    for (let listener of Object.values(OfflineModeSimulator.listeners)) {
      listener(this.isEnabled);
    }
  }

  public checkEnabled(): boolean {
    return this.isEnabled;
  }

  public async clearOfflineAsyncStorage() {
    await clearOfflineAsyncStorage();
    await AsyncStorage.removeItem(OFFLINE_MODE_SIMULATED_KEY);
  }

  addEventListener(callback: (isEnabled: boolean) => void) {
    const listenerId = uuidv4();
    if (!OfflineModeSimulator.listeners) {
      OfflineModeSimulator.listeners = {};
    }

    OfflineModeSimulator.listeners[listenerId] = callback;
    return listenerId;
  }

  removeEventListener(listenerId: string) {
    delete OfflineModeSimulator.listeners[listenerId];
  }
}
